import React, { useEffect, useState } from "react";
import {
  CommitManualMatching,
  displayAttributesTooltip,
} from "@helpers/helpers";
import { GetSFMDisplay } from "@helpers/helpers";
import SfmModalStore from "@stores/SfmModalStore";
import Confirmationpopup from "@components/ConfirmationPopup";
import { fetchDynamicTags, FormatWithCommas } from "@helpers/helpers";
import TooltipComponent from "@components/TooltipComponent";

import { ZERO_VALUE, ONE_VALUE } from "@utils/constants";
import {
  FIRST_INDEX,
  REDUCE_TIMEOUT,
  TOOLTIP_TIMEOUT,
  getFilterValues,
  getTableColumns,
} from "./constants";
import SectionRenderer from "./SectionRenderer";
import RecordsTableRenderer from "./RecordsTableRenderer";
import VarianceRow from "./VarianceRow";
import ActionHeader from "./ActionHeader";
import LoadingOverlay from "./LoadingOverlay";

const CorrectiveActionComponent = ({
  correctiveAction,
  setPopupOpen,
  MatchingRequestId,
  resetComponent,
  translate,
}) => {
  const filterValues = getFilterValues(translate);

  const defaultValues = () => {
    return correctiveAction.map((singleAction) => {
      return {
        CorrectionResultId: singleAction?.CorrectionResultId,
        CorrectionResultTag: singleAction?.CorrectionResultTag,
        CorrectionResultName: singleAction?.CorrectionResultName,
      };
    });
  };

  const [externalOpenConfirmationAction, setExternalOpenConfirmationAction] =
    useState(false);
  const [dynamicTags, setDynamicTags] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCorrectiveReason, setSelectedCorrectiveReason] = useState(
    defaultValues() || []
  );
  const [isEditing, setIsEditing] = useState(false);
  const [currentTooltip, setCurrentTooltip] = useState(null);

  const [sourceAmount, setSourceAmount] = useState(
    correctiveAction.map((action) => action?.SourceAmount)
  );
  const [destinationAmount, setDestinationAmount] = useState(
    correctiveAction.map((action) => action?.DestinationAmount)
  );

  const columns = getTableColumns(
    translate,
    FormatWithCommas,
    setCurrentTooltip,
    TOOLTIP_TIMEOUT
  );

  useEffect(() => {
    fetchDynamicTags("Lists", ["CORRECTIVE_ACTION_REASONS"], (newTags) => {
      setDynamicTags(newTags);
    });
  }, []);

  const updatedCorrectiveActions = correctiveAction.map((action, index) => {
    const isManuallyCleared =
      selectedCorrectiveReason[index]?.CorrectionResultTag ===
      "MANUALLY_CLEARED";
    return {
      CorrectionResultId: action?.CorrectionResultId,
      CorrectionResultName:
        selectedCorrectiveReason[index]?.CorrectionResultName,
      CorrectionResultTag: selectedCorrectiveReason[index]?.CorrectionResultTag,
      AdjustedSourceAmount: isManuallyCleared
        ? parseInt(sourceAmount[index]) !== parseInt(action.SourceAmount)
          ? sourceAmount[index]
          : null
        : null,
      AdjustedDestinationAmount: isManuallyCleared
        ? parseInt(destinationAmount[index]) !==
          parseInt(action.DestinationAmount)
          ? destinationAmount[index]
          : null
        : null,
    };
  });

  return (
    <div className="relative">
      <LoadingOverlay isLoading={isLoading} />
      <ActionHeader
        translate={translate}
        onCancel={() => {
          setPopupOpen(false);
        }}
        onProceed={() => setExternalOpenConfirmationAction(true)}
        isEditing={isEditing}
      />
      {correctiveAction &&
        correctiveAction.map((singleAction, index) => {
          const rowData = VarianceRow({
            singleAction,
            index,
            correctiveAction,
            filterValues,
            sourceAmount: sourceAmount[index],
            destinationAmount: destinationAmount[index],
            setSourceAmount,
            setDestinationAmount,
            setSelectedCorrectiveReason,
            selectedCorrectiveReason,
            translate,
            renderSection: SectionRenderer,
            setIsEditing,
          });

          return (
            <div key={index} className="border-2 border-gray-200 my-5 dark:bg-gray-700 dark:border-gray-600 dark:text-white ">
              <SectionRenderer
                identifier=""
                title=""
                data={singleAction}
                allowedKeys={[
                  "CorrectionResultName",
                  "DestinationAmount",
                  "SourceAmount",
                  rowData.keyToPass,
                ]}
                displayValues={rowData.displayValues}
                customValues={rowData.customValues}
              />
              <RecordsTableRenderer
                singleAction={singleAction}
                correctiveActionCount={correctiveAction?.length}
                columns={columns}
                translate={translate}
                correctiveAction={correctiveAction}
              />
            </div>
          );
        })}
      {externalOpenConfirmationAction && (
        <Confirmationpopup
          singleAction={{
            actionFN: (selectedReason, reasonDescription) => {
              setIsLoading(true);
              CommitManualMatching(
                MatchingRequestId,
                selectedReason,
                reasonDescription,
                updatedCorrectiveActions,
                (data) => {
                  const sfmData = GetSFMDisplay(data.SFM);
                  setIsLoading(false);
                  SfmModalStore.open(sfmData, () => {
                    window.location.href = "/exception-list";
                  });
                }
              );
            },
            confirmation: true,
            confirmationMessage:
              "Do you want to start attempt matching process? Please confirm if you wish to proceed.",
            severity: "medium",
            showReason: true,
            actionTypeTag: "MANUAL_MATCHING",
          }}
          setOpenConfirmationAction={setExternalOpenConfirmationAction}
          dynamicTags={dynamicTags}
        />
      )}
      <TooltipComponent
        anchorElement={"attributes-tooltip"}
        toolTipMessage={displayAttributesTooltip(currentTooltip)}
        position="top"
        className="max-w-max z-50 !bg-gray-500"
      />
    </div>
  );
};

export default CorrectiveActionComponent;
